import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './JobDetail.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const JobDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/rfqs/${id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success && data.rfq) {
          setJob(data.rfq);
        } else {
          setError(data.message || 'Job details not found');
        }
      } catch (err) {
        setError('Network error tracking details');
      } finally {
        setLoading(false);
      }
    };
    if (id && token) fetchJobDetails();
  }, [id, token]);

  if (loading) return <div className="loader-container"><i className="fa-solid fa-spinner fa-spin"></i></div>;
  if (error) return <div className="jd-wrapper" style={{ textAlign: 'center', padding: '40px' }}>{error}</div>;
  if (!job) return <div className="jd-wrapper" style={{ textAlign: 'center', padding: '40px' }}>Job not found</div>;

  const getStatusText = (status) => {
    if (status === 'open') return 'Open For Bids';
    if (status === 'bidding') return 'Reviewing Offers';
    if (status === 'in_progress') return 'In Progress';
    if (status === 'completed') return 'Completed';
    return status;
  };

  return (
    <div className="jd-wrapper">
      <button className="jd-btn-back" onClick={() => navigate(-1)}>
        <i className="fa-solid fa-arrow-left"></i> Back
      </button>

      <div className="jd-header-section">
        <div className="jd-title">
          <h1><i className="fa-solid fa-briefcase"></i> {job.vesselName}</h1>
          <p>JOB ID: #{job._id?.slice(-8).toUpperCase()}</p>
        </div>
        <div className={`jd-status-badge ${job.status === 'bidding' ? 'bidding' : ''}`}>
          <i className="fa-solid fa-circle-dot"></i> {getStatusText(job.status)}
        </div>
      </div>

      <div className="jd-section">
        <h2 className="jd-section-title"><i className="fa-solid fa-ship"></i> Vessel Specifications</h2>
        <div className="jd-grid">
          <div className="jd-info-item"><span className="jd-label">Vessel Name</span><span className="jd-value">{job.vesselName}</span></div>
          <div className="jd-info-item"><span className="jd-label">IMO Number</span><span className="jd-value">{job.vesselId?.imo || 'N/A'}</span></div>
          <div className="jd-info-item"><span className="jd-label">Port Location</span><span className="jd-value">{job.port}</span></div>
          <div className="jd-info-item"><span className="jd-label">Class Approval Requirement</span><span className="jd-value">{job.classApproval || 'None Specified'}</span></div>
        </div>
      </div>

      <div className="jd-section">
        <h2 className="jd-section-title"><i className="fa-solid fa-gears"></i> Service Details</h2>
        <div className="jd-grid">
          <div className="jd-info-item"><span className="jd-label">Requested Service</span><span className="jd-value">{job.serviceType}</span></div>
          <div className="jd-info-item"><span className="jd-label">Bidding Deadline</span><span className="jd-value">{job.deadline ? new Date(job.deadline).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A'}</span></div>
          <div className="jd-info-item"><span className="jd-label">Budget Configuration</span><span className="jd-value" style={{ textTransform: 'uppercase' }}>{job.budgetType}</span></div>
          <div className="jd-info-item">
            <span className="jd-label">Budget Limit</span>
            <span className="jd-value-highlight">
              {job.budgetType === 'quotation' ? 'Requesting Quotes Only' : `${job.currency || 'USD'} ${job.budgetMin?.toLocaleString()} - ${job.budgetMax?.toLocaleString()}`}
            </span>
          </div>
        </div>
      </div>

      <div className="jd-section">
        <h2 className="jd-section-title"><i className="fa-solid fa-align-left"></i> Scope of Work</h2>
        <div className="jd-info-item" style={{ background: '#111111' }}>
          <p className="jd-description-text">{job.description}</p>
        </div>
      </div>

      <div className="jd-actions">
        <button type="button" className="jd-btn jd-btn-secondary" onClick={() => navigate('/owner/my-jobs-quotations')}>
          View All Quotations
        </button>
        {job.status !== 'completed' && job.status !== 'in_progress' && (
          <button type="button" className="jd-btn jd-btn-primary" onClick={() => navigate(`/owner/edit-job/${job._id}`)}>
            <i className="fa-regular fa-pen-to-square"></i> Edit Requirements
          </button>
        )}
      </div>
    </div>
  );
};

export default JobDetail;